import { ProductItemId } from '../types';

export type DelayInfo = {
  id: ProductItemId;
  delay: boolean;
}[];

export const getDelayInfo = (): Promise<DelayInfo> =>
  new Promise((resolve) => {
    let delayInfoTimeout: NodeJS.Timeout | null = null;

    const delayInfoGetter = (
      event: CustomEvent<DelayInfo>
    ) => {
      resolve(event.detail);

      clearTimeout(delayInfoTimeout);
      document.removeEventListener(
        'setCartDelayData',
        delayInfoGetter
      );
    };

    document.addEventListener(
      'setCartDelayData',
      delayInfoGetter
    );

    document.dispatchEvent(
      new CustomEvent('getCartDelayData')
    );

    delayInfoTimeout = setTimeout(() => {
      document.removeEventListener(
        'setCartDelayData',
        delayInfoGetter
      );

      resolve([]);
    }, 300);
  });
